import { appAssetsCdnUrl } from '~/constants/environment';
import optimizeImage from '~/utilities/optimizeImage';
import toLowerKebabCase from '~/utilities/toLowerKebabCase';

const MAKE_MODELS: Record<string, string[]> = {
  chrysler: ['Pacifica', 'Voyager'],
  dodge: ['Charger', 'Charger Daytona', 'Durango'],
  jeep: [
    'Cherokee',
    'Compass',
    'Gladiator',
    'Grand Cherokee',
    'Grand Wagoneer',
    'Wrangler'
  ],
  ram: ['1500', '2500', '3500', 'ProMaster']
};

export function getNewCarModels(make: string): string[] {
  return MAKE_MODELS[toLowerKebabCase(make)] ?? [];
}

export function getModelAssetSrc(make: string, model: string): string {
  return optimizeImage(
    `${appAssetsCdnUrl}/images/new-car/${toLowerKebabCase(
      make
    )}/${toLowerKebabCase(model)}-mobile.png`,
    { format: 'auto', quality: 90 }
  );
}
